import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'

export const FWIDTH = 130

export const factor_fields = 'date,hold_rate'
export const vanaly_fields = 'index,curr_date,curr_hold,curr_mnys,hope_rate,curr_rate,gain_rate,base_rate'
// 字段定义
export const FIELD_ANALY = DATAS.fieldsToFieldsIndex(vanaly_fields)

export function VdatesToAnaly(vdates, factor) {
    // let facts = factorToFdates(factor)
    // console.log(facts, vdates.datas.length);
    let kbars = []
    for (let index = 0; index < vdates.datas.length; index++) {
        // let hope_rate = CLAPI.getData(facts,  'hold_rate', index)
        // if (CLAPI.getData(facts,  'date', index) !== CLAPI.getData(vdates, 'curr_date', index)) {
        //     console.log(CLAPI.getData(facts,  'date', index), CLAPI.getData(vdates, 'curr_date', index));
        // }
        kbars.push(
            [   index,
                CLAPI.getData(vdates, 'curr_date', index),
                CLAPI.getData(vdates, 'curr_hold', index),
                CLAPI.getData(vdates, 'curr_hold', index) + CLAPI.getData(vdates, 'surp_mnys', index),
                CLAPI.getData(vdates, 'hope_rate', index),
                CLAPI.getData(vdates, 'curr_rate', index),
                CLAPI.getData(vdates, 'gain_rate', index),
                CLAPI.getData(vdates, 'base_rate', index),
            ])
    }
    return {
        fields: FIELD_ANALY,
        datas: kbars
    }
}

export const analy_sydb_lines = [{
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['base_rate'], // 参与计算最大值的标签
            minvalue: ['base_rate'] // 参与计算最小值的标签
        },
        info: {
            label: '指数收益:',
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'base_rate', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    }, {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['gain_rate'], // 参与计算最大值的标签
            minvalue: ['gain_rate'] // 参与计算最小值的标签
        },
        info: {
            label: '超额收益:',
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'gain_rate', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
]

export const analy_yzcc_lines = [{
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['curr_rate'], // 参与计算最大值的标签
            minvalue: ['curr_rate'] // 参与计算最小值的标签
        },
        info: {
            label: '实际持仓:',
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'curr_rate', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['hope_rate'], // 参与计算最大值的标签
            minvalue: ['hope_rate'] // 参与计算最小值的标签
        },
        info: {
            label: '期望持仓:',
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'hope_rate', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '10:',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float'
        },
        formula: {
            key: 'MA1', // 获取数据的key，
            command: `out = this.MA('hope_rate',10)` // 公式只能输出值到out中
        }
    },

]
export const analy_zcfx_lines = [{
        className: CLAPI.ClDrawVLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['curr_hold'], // 参与计算最大值的标签
            minvalue: [0] // 参与计算最小值的标签
        },
        info: {
            label: '当前持仓',
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            color: 'yellow',
            fieldX: 'index',
            fieldY: 'curr_hold', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['curr_mnys'], // 参与计算最大值的标签
            minvalue: ['curr_mnys'] // 参与计算最小值的标签
        },
        info: {
            label: '当前资产',
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            color: 'red',
            fieldX: 'index',
            fieldY: 'curr_mnys', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money',
        }
    }

]